export const CODE_API_SETUP_ERR = 'CODE_API_SETUP_ERR'
export const CODE_API_TIMEOUT_ERR = 'CODE_API_TIMEOUT_ERR'
export const CODE_API_FAILED_TO_RESPOND = 'CODE_API_FAILED_TO_RESPOND'
export const CODE_API_NON_200 = 'CODE_API_NON_200'
export const CODE_API_UNKNOWN_ERROR = 'CODE_API_UNKNOWN_ERROR'
